module.exports = __webpack_public_path__ + "cd3ec8c4ebe9cd3c23e82e62fef4f6ef.pdf";